// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"qDA0AN0i"};